import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CompareState {
  compareCollege: any[];
  compareCourse: any[];
  compareTab:string;
  compareCollegeData: any;
  compareCourseData: any;
  compareCollegeSearchText: string;
  compareCourseSearchText : string;
}

const initialState: CompareState = {
  compareCollege: [],
  compareCourse: [],
  compareTab: 'college',
  compareCollegeData: null,
  compareCourseData: null,
  compareCollegeSearchText: '',
  compareCourseSearchText:''
};

const compareSlice = createSlice({
  name: 'compare',
  initialState,
  reducers: {
    setCompareTab:(state, action)=>{
      state.compareTab =action.payload
    },
    addToCompareCollege: (state, action: PayloadAction<any>) => {
      if (state.compareCollege.length < 3) {
        const exists = state.compareCollege.some(item => item._id === action.payload._id);
        if (!exists) state.compareCollege.push(action.payload);
      }
    },
    removeFromCompareCollege: (state, action: PayloadAction<string>) => {
      state.compareCollege = state.compareCollege.filter(item => item._id !== action.payload);
    },
    addToCompareCourse: (state, action: PayloadAction<any>) => {
      if (state.compareCourse.length < 3) {
        const exists = state.compareCourse.some(item => item._id === action.payload._id);
        if (!exists) state.compareCourse.push(action.payload);
      }
    },
    removeFromCompareCourse: (state, action: PayloadAction<string>) => {
      state.compareCourse = state.compareCourse.filter(item => item._id !== action.payload);
    },
    setCompareCollegeData:(state, action: PayloadAction<any>)=>{
      state.compareCollegeData = action.payload;
    },
    setCompareCourseData:(state, action: PayloadAction<any>)=>{
      state.compareCourseData= action.payload;
    },
    setCompareCollegeSearchText: (state, action: PayloadAction<string>)=>{
      state.compareCollegeSearchText = action.payload;
    },
    setCompareCourseSearchText:(state, action: PayloadAction<string>)=>{
      state.compareCourseSearchText = action.payload;
    },
    clearCompareState: (state) => {
      state.compareCollege = [];
      state.compareCourse = [];
      state.compareTab = 'college';
      state.compareCollegeData = null;
      state.compareCourseData = null;
      state.compareCollegeSearchText = '';
      state.compareCourseSearchText = '';
    }
  },
});

export const {
  setCompareTab,
  addToCompareCollege,
  removeFromCompareCollege,
  addToCompareCourse,
  removeFromCompareCourse,
  setCompareCollegeData,
  setCompareCourseData,
  setCompareCollegeSearchText,
  setCompareCourseSearchText,
  clearCompareState
} = compareSlice.actions;

export default compareSlice.reducer;
